import { render, staticRenderFns } from "./CreateKlaimPp.vue?vue&type=template&id=001d0768&scoped=true&"
import script from "./CreateKlaimPp.vue?vue&type=script&lang=js&"
export * from "./CreateKlaimPp.vue?vue&type=script&lang=js&"
import style0 from "./CreateKlaimPp.vue?vue&type=style&index=0&id=001d0768&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001d0768",
  null
  
)

export default component.exports